"use strict";
/// <reference types="bip32/types/crypto" />
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Mnemonic_mnemonic;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mnemonic = void 0;
const hash_wasm_1 = require("hash-wasm");
const web_encoding_1 = require("web-encoding");
const bip32_1 = require("./bip32");
const revocable_1 = require("./revocable");
__exportStar(require("../../core/bip39"), exports);
class Mnemonic extends (0, revocable_1.Revocable)(class {
}) {
    constructor(mnemonic) {
        super();
        _Mnemonic_mnemonic.set(this, void 0);
        __classPrivateFieldSet(this, _Mnemonic_mnemonic, mnemonic.normalize("NFKD"), "f");
    }
    static create(mnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            const obj = new Mnemonic(mnemonic);
            return (0, revocable_1.revocable)(obj, (x) => obj.addRevoker(x));
        });
    }
    toSeed(passphrase) {
        return __awaiter(this, void 0, void 0, function* () {
            const mnemonic = __classPrivateFieldGet(this, _Mnemonic_mnemonic, "f");
            const salt = new web_encoding_1.TextEncoder().encode(`mnemonic${passphrase !== null && passphrase !== void 0 ? passphrase : ""}`.normalize("NFKD"));
            const out = yield bip32_1.Seed.create(Buffer.from(yield (0, hash_wasm_1.pbkdf2)({
                password: mnemonic,
                salt,
                iterations: 2048,
                hashLength: 64,
                hashFunction: (0, hash_wasm_1.createSHA512)(),
                outputType: "binary",
            })));
            this.addRevoker(() => { var _a; return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out); });
            return out;
        });
    }
}
exports.Mnemonic = Mnemonic;
_Mnemonic_mnemonic = new WeakMap();
//# sourceMappingURL=bip39.js.map